import BuildingType from '@/roc/building/BuildingType';
import Effects from '@/roc/effects/Effects';
import ProductionOutputType from '@/roc/effects/Production/ProductionOutputType';
import PassiveProduction from '@/roc/effects/Production/PassiveProduction';
import ProductionDuration from '@/roc/effects/Production/ProductionDuration';
import ProductionOutput from '@/roc/effects/Production/ProductionOutput';

const HydraMonument = {
  id: '34',
  name: "Hydra Monument",
  width: 4,
  height: 4,
  type: BuildingType.EVENT,
  era: 'stoneAge',
  icon: 'Hydra_Monument',
  minLevel: 1,
  maxLevel: 60,
  url: 'https://riseofcultures.wiki.gg/wiki/Buildings/Hydra_Monument',
  flags: 0,
  counts: null,
  effects: Effects.create([
    new PassiveProduction(
      ProductionDuration.asDaily(),
      ProductionOutput.asCallbackWithLevel(
        (level) => {
          if (level <= 5) {
            return 0;
          }
          if (level <= 10) {
            return 1;
          }
          if (level <= 15) {
            return 2;
          }
          if (level <= 20) {
            return 3;
          }
          if (level <= 30) {
            return 4;
          }
          if (level <= 40) {
            return 5;
          }
          if (level <= 41) {
            return 6;
          }
          if (level <= 47) {
            return 7;
          }
          if (level <= 53) {
            return 8;
          }
          if (level <= 59) {
            return 9;
          }
          return 10;
        }
      ).withOutput(ProductionOutputType.RESEARCH_POINTS),
    ),
    new PassiveProduction(
      ProductionDuration.asDaily(),
      ProductionOutput.asPerEraAndLevel({
        stoneAge: [
          0,0,12,12,16,16,16,21,21,24,24,24,28,28,31,31,31,34,34,37,37,37,40,40,42,42,44,44,46,46,46,48,48,50,50,52,52,54,54,55,56,57,58,59,60,61,63,64,65,66,67,68,69,71,72,73,74,75,76,78
        ],
        bronzeAge: [
          0,0,12,12,16,16,16,21,21,24,24,24,28,28,31,31,31,34,34,37,37,37,40,40,42,42,44,44,46,46,46,48,48,50,50,52,52,54,54,55,56,57,58,59,60,61,63,64,65,66,67,68,69,71,72,73,74,75,76,78
        ],
        minoanEra: [
          0,0,17,17,22,22,22,30,30,34,34,34,39,39,43,43,43,48,48,51,51,51,55,55,58,58,61,61,64,64,64,68,68,70,70,72,72,75,75,77,79,81,83,84,86,88,89,91,93,95,96,98,100,101,103,105,106,108,110,112
        ],
        classicGreece: [
          0,0,21,21,29,29,29,38,38,43,43,43,51,51,55,55,55,62,62,66,66,66,71,71,75,75,78,78,82,82,82,87,87,90,90,93,93,96,96,99,101,103,105,107,109,111,113,115,117,120,122,124,126,128,130,132,134,136,138,141
        ],
        earlyRome: [
          0,0,26,26,35,35,35,46,46,53,53,53,62,62,67,67,67,75,75,80,80,80,87,87,91,91,96,96,100,100,100,106,106,110,110,114,114,117,117,121,123,126,128,131,133,136,138,141,143,146,148,151,153,156,158,161,163,166,168,171
        ],
        romanEmpire: [
          0,0,30,30,41,41,41,55,55,62,62,62,73,73,80,80,80,89,89,94,94,94,103,103,108,108,113,113,118,118,118,125,125,130,130,134,134,139,139,143,146,149,152,155,158,161,164,167,170,173,176,179,182,185,188,191,194,197,200,203
        ],
        byzantineEra: [
          0,0,30,30,41,41,41,55,55,62,62,62,73,73,80,80,80,89,89,94,94,94,103,103,108,108,113,113,118,118,118,125,125,130,130,134,134,139,139,143,146,149,152,155,158,161,164,167,170,173,176,179,182,185,188,191,194,197,200,203
        ],
        ageOfTheFranks: [
          0,0,30,30,41,41,41,55,55,62,62,62,73,73,80,80,80,89,89,94,94,94,103,103,108,108,113,113,118,118,118,125,125,130,130,134,134,139,139,143,146,149,152,155,158,161,164,167,170,173,176,179,182,185,188,191,194,197,200,203
        ],
        feudalAge: [
          0,0,30,30,41,41,41,55,55,62,62,62,73,73,80,80,80,89,89,94,94,94,103,103,108,108,113,113,118,118,118,125,125,130,130,134,134,139,139,143,146,149,152,155,158,161,164,167,170,173,176,179,182,185,188,191,194,197,200,203
        ],
        iberianEra: [
          0,0,30,30,41,41,41,55,55,62,62,62,73,73,80,80,80,89,89,94,94,94,103,103,108,108,113,113,118,118,118,125,125,130,130,134,134,139,139,143,146,149,152,155,158,161,164,167,170,173,176,179,182,185,188,191,194,197,200,203
        ],
        kingdomOfSicily: [
          0,0,30,30,41,41,41,55,55,62,62,62,73,73,80,80,80,89,89,94,94,94,103,103,108,108,113,113,118,118,118,125,125,130,130,134,134,139,139,143,146,149,152,155,158,161,164,167,170,173,176,179,182,185,188,191,194,197,200,203
        ],
        highMiddleAges: [
          0,0,30,30,41,41,41,55,55,62,62,62,73,73,80,80,80,89,89,94,94,94,103,103,108,108,113,113,118,118,118,125,125,130,130,134,134,139,139,143,146,149,152,155,158,161,164,167,170,173,176,179,182,185,188,191,194,197,200,203
        ],
        earlyGothicEra: [
          0,0,30,30,41,41,41,55,55,62,62,62,73,73,80,80,80,89,89,94,94,94,103,103,108,108,113,113,118,118,118,125,125,130,130,134,134,139,139,143,146,149,152,155,158,161,164,167,170,173,176,179,182,185,188,191,194,197,200,203
        ],
        lateGothicEra: [
          0,0,30,30,41,41,41,55,55,62,62,62,73,73,80,80,80,89,89,94,94,94,103,103,108,108,113,113,118,118,118,125,125,130,130,134,134,139,139,143,146,149,152,155,158,161,164,167,170,173,176,179,182,185,188,191,194,197,200,203
        ]
      }).withOutput(ProductionOutputType.ALL_CURRENT_ERA_GOODS),
    ),
    new PassiveProduction(
      ProductionDuration.asDaily(),
      ProductionOutput.asPerEraAndLevel({
        stoneAge: [
          3350,5050,5050,7650,7650,7650,10700,10700,12400,12400,12400,14800,14800,16200,16200,16200,18200,18200,19500,19500,19500,21300,21300,22400,22400,23500,23500,24600,24600,25600,25600,25600,27100,27100,28100,28100,29000,29000,30000,30500,31000,31500,32000,32500,33000,33500,34000,34500,35000,35500,36000,36500,37000,37500,38000,38500,39000,39500,40000,40500
        ],
        bronzeAge: [
          4300,6550,6550,9900,9900,9900,13800,13800,16100,16100,16100,19100,19100,21000,21000,21000,23600,23600,25200,25200,25200,27500,27500,29000,29000,30400,30400,31800,31800,33100,33100,33100,35100,35100,36300,36300,37600,37600,38800,39400,40000,40600,41200,41800,42400,43000,43600,44200,44800,45400,46000,46600,47200,47800,48400,49000,49600,50200,50800,51400
        ],
        minoanEra: [
          7550,11500,11500,17400,17400,17400,24300,24300,28300,28300,28300,33600,33600,36800,36800,36800,41400,41400,44200,44200,44200,48300,48300,50900,50900,53400,53400,55800,55800,58200,58200,58200,61600,61600,63800,63800,66000,66000,68100,69150,70200,71250,72300,73350,74400,75450,76500,77550,78600,79650,80700,81750,82800,83850,84900,85950,87000,88050,89100,90150
        ],
        classicGreece: [
          11100,16900,16900,25600,25600,25600,35800,35800,41600,41600,41600,49400,49400,54200,54200,54200,60900,60900,65100,65100,65100,71100,71100,74900,74900,78600,78600,82200,82200,85700,85700,85700,90700,90700,94000,94000,97100,97100,100000,101450,102900,104350,105800,107250,108700,110150,111600,113050,114500,115950,117400,118850,120300,121750,123200,124650,126100,127550,129000,130450
        ],
        earlyRome: [
          13200,20100,20100,30400,30400,30400,42500,42500,49400,49400,49400,58800,58800,64500,64500,64500,72400,72400,77400,77400,77400,84500,84500,89100,89100,93400,93400,97700,97700,102000,102000,102000,108000,108000,112000,112000,115000,115000,119000,121000,123000,125000,127000,129000,131000,133000,135000,137000,139000,141000,143000,145000,147000,149000,151000,153000,155000,157000,159000,161000
        ],
        romanEmpire: [
          15400,23400,23400,35500,35500,35500,49600,49600,57700,57700,57700,68600,68600,75200,75200,75200,84500,84500,90300,90300,90300,98600,98600,104000,104000,109000,109000,114000,114000,119000,119000,119000,126000,126000,130000,130000,135000,135000,139000,141000,143000,145000,147000,149000,151000,153000,155000,157000,159000,161000,163000,165000,167000,169000,171000,173000,175000,177000,179000,181000
        ],
        byzantineEra: [
          18100,27400,27400,41500,41500,41500,58000,58000,67500,67500,67500,80200,80200,88000,88000,88000,98900,98900,106000,106000,106000,115000,115000,122000,122000,128000,128000,133000,133000,139000,139000,139000,147000,147000,152000,152000,158000,158000,163000,165500,168000,170500,173000,175500,178000,180500,183000,185500,188000,190500,193000,195500,198000,200500,203000,205500,208000,210500,213000,215500
        ],
        ageOfTheFranks: [
          22100,33400,33400,50600,50600,50600,70700,70700,82300,82300,82300,97800,97800,107000,107000,107000,121000,121000,129000,129000,129000,140000,140000,149000,149000,156000,156000,162000,162000,170000,170000,170000,179000,179000,185000,185000,193000,193000,199000,202000,205000,208000,211000,214000,217000,220000,223000,226000,229000,232000,235000,238000,241000,244000,247000,250000,253000,256000,259000,262000
        ],
        feudalAge: [
          26000,39300,39300,59500,59500,59500,83200,83200,96800,96800,96800,115000,115000,126000,126000,126000,142000,142000,152000,152000,152000,165000,165000,175000,175000,184000,184000,191000,191000,200000,200000,200000,211000,211000,218000,218000,227000,227000,234000,237500,241000,244500,248000,251500,255000,258500,262000,265500,269000,272500,276000,279500,283000,286500,290000,293500,297000,300500,304000,307500
        ],
        iberianEra: [
          30600,46200,46200,70000,70000,70000,97900,97900,114000,114000,114000,135000,135000,148000,148000,148000,167000,167000,179000,179000,179000,194000,194000,206000,206000,216000,216000,225000,225000,235000,235000,235000,248000,248000,256000,256000,267000,267000,275000,279000,283000,287000,291000,295000,299000,303000,307000,311000,315000,319000,323000,327000,331000,335000,339000,343000,347000,351000,355000,359000
        ],
        kingdomOfSicily: [
          32000,48300,48300,73200,73200,73200,102000,102000,119000,119000,119000,141000,141000,155000,155000,155000,175000,175000,187000,187000,187000,203000,203000,216000,216000,226000,226000,235000,235000,246000,246000,246000,259000,259000,268000,268000,279000,279000,288000,292500,297000,301500,306000,310500,315000,319500,324000,328500,333000,337500,342000,346500,351000,355500,360000,364500,369000,373500,378000,382500
        ],
        highMiddleAges: [
          35000,53000,53000,80500,80500,80500,112000,112000,130000,130000,130000,155000,155000,170000,170000,170000,192500,192500,205000,205000,205000,223000,223000,238000,238000,250000,250000,260000,260000,270000,270000,270000,285000,285000,295000,295000,307000,307000,317000,322000,327000,332000,337000,342000,347000,352000,357000,362000,367000,372000,377000,382000,387000,392000,397000,402000,407000,412000,417000,422000
        ],
        earlyGothicEra: [
          38700,58400,58400,88600,88600,88600,123400,123400,144000,144000,144000,170600,170600,187600,187600,187600,211800,211800,226300,226300,226300,245600,245600,261400,261400,273500,273500,284400,284400,297700,297700,297700,313400,313400,324300,324300,337700,337700,348700,354200,359700,365200,370700,376200,381700,387200,392700,398200,403700,409200,414700,420200,425700,431200,436700,442200,447700,453200,458700,464200
        ],
        lateGothicEra: [
          0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0
        ]
      }).withOutput(ProductionOutputType.FOOD),
    ),
  ]),
};

export default HydraMonument;
